import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rich-text-content"
export default class extends Controller {
  connect() {
    this.swapLinks()
    this.formatParagraphs()
    this.swapTitles()
  }

  swapLinks() {
    const links = this.element.querySelectorAll('a')
    
    for (let i = 0; i < links.length; i++) {
      links[i].setAttribute('target', '_blank')
      links[i].classList.add('color--primary')
    }
  }
  
  formatParagraphs() {
    // 1 enter outputs <br>, 2 enter outputs <p>
    let content = this.element.innerHTML;
    content = content.replace(/(<br\s*\/?>\s*){2,}/g, '</p><p>');
    content = content.replace(/<div>(.*?)<\/div>/g, '<p>$1</p>'); // Wrap everything inside <p>
    content = content.replace(/<\/p><p>(.*?)<br>/g, '<p>$1<br>'); // Ensure <br> stays in the same <p>
    content = content.replace(/<p>\s*<\/p>/g, '');

    this.element.innerHTML = content;
  }

  swapTitles() {
    const titles  = this.element.querySelectorAll('h1')

    for (let i = 0; i < titles.length; i++) {
      titles[i].outerHTML = '<h2>' + titles[i].innerHTML + '</h2>'
    }
  }
}
